import { schema } from 'normalizr';

const circle = new schema.Entity('circles');
const type   = new schema.Entity('types');
const fund = new schema.Entity('funds');
const year = new schema.Entity('years');
export const file = new schema.Entity('files', {
	circles: [ circle ],
	types: [ type ],
	funds: [ fund ],
	years: [ year ],
});
export const notification = new schema.Entity('notifications');


// WEBPACK FOOTER //
// ./src/store/schema.js